import MyQueueContainer from './my-queue-container';

export default MyQueueContainer;
